import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var baseLabel = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_10772fr0',variantClassNames:{state:{'default':'fx_2d2fb1e5_10772fr1',error:'fx_2d2fb1e5_10772fr2'},disabled:{true:'fx_2d2fb1e5_10772fr3'},required:{true:'fx_2d2fb1e5_10772fr4'}},defaultVariants:{state:'default'},compoundVariants:[]});

export { baseLabel };
//# sourceMappingURL=baseLabel.vanilla.mjs.map
